import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Global } from '../global/globalApi';
import { RootScopeService } from '../services/root-scope.service';
import * as Constants from 'src/app/models/Constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isAuthenticate: boolean = false;

  constructor(public rootScope: RootScopeService, public router: Router) {
    this.rootScope.isAuthenticated().subscribe((res) => {
      this.isAuthenticate = res;
      this.rootScope.isAuthenticate = res;
    });
  }

  /**Here main component will launch only when user is loggged in else it will redirect to login page */
  canActivate(): boolean {
    // console.log("isSSODuplicate", this.rootScope.isSSODuplicate, "localStorage.getItem('sessionId')" + !(sessionStorage.getItem('sessionId')))
    if (!sessionStorage.getItem('sessionId') && !this.rootScope.launchAppFromManualLogin) {
      let currentURL = window.location.href;
      if (currentURL.includes(Constants.LOCAL_ANGULAR_APIURL)) {
        this.router.navigate(['login']); return false;
      } else { window.location.href = `${Global.domainUrl}awcp/oauth2/authorization/pingidentity`; return false; }
    }
    else if (this.rootScope.isSSODuplicate || this.rootScope.launchAppBySSO) {
      return true;
    }
    else if (!this.rootScope.launchAppFromManualLogin && !(sessionStorage.getItem('sessionId'))) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
